import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Formatter from '../../utils/Formatter';
import SelectEvent from '../controls/SelectEvent.jsx';
import '../../../resources/css/relatorio.css';

class View extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_DASHBOARD)
            return null;

        const token = this.props.token;
        const relatorio = this.props.relatorioDashboard;
        const selectedEvent = this.props.participants.selectedEvent || {};
        const atualizarDashboard = (e) => {
            e.preventDefault();
            this.props.events.onUpdateDashboard(token, selectedEvent.id);
        };

        const colors = [
            "#26c281",
            "#4b77be",
            "#ef4836",
            "#f3c200",
            "#8e44ad",
            "#67809f",
            "#44b6ae",
            "#95a5a6",
            "#e43a45",
            "#f2784b",
            "#9b59b6",
        ];

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Dashboard</h2>
                    </div>
                </div>

                <SelectEvent {...this.props} handleChange={selectedValue => this.props.events.onUpdateDashboard(token, selectedValue)}/>

                <div className="row">
                    <div className="col-md-12">
                        <h4>Relatório Geral de Vendas <button className="btn btn-primary btn-sm" onClick={atualizarDashboard}>Atualizar</button></h4>
                    </div>
                </div>

                <div className="row">
                    {relatorio.results.map(function (result, index) {
                        let style = { backgroundColor: colors[index] };

                        return (
                            <div key={result.name} className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div className="relatorio-card" style={style}>
                                    <div className="rel-value">{Formatter.money(result.total)}</div>
                                    <div className="rel-label">{result.name}</div>
                                    <div className="rel-sublabel">
                                        (Pago: {Formatter.money(result.total - result.toPay)}; À receber: {Formatter.money(result.toPay)})
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default View;


// WEBPACK FOOTER //
// src/views/pages/RelatorioDashboard.jsx